import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch Z Report data
export const getZReport = async (filter = {}) => {
  console.log("🌐 [API] getZReport called");
  console.log("🌐 [API] BASE_URL:", BASE_URL);
  console.log("🌐 [API] Endpoint:", `${BASE_URL}/api/DayClosing/get-z-report`);
  console.log("🌐 [API] Filter:", JSON.stringify(filter, null, 2));
  console.log("🌐 [API] Headers:", getAuthHeader());
  
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-z-report`, filter, {
      headers: getAuthHeader(),
    });
    
    console.log("🌐 [API] Response status:", response.status);
    console.log("🌐 [API] Response headers:", response.headers);
    console.log("🌐 [API] Response data:", response.data);
    console.log("🌐 [API] Response data type:", typeof response.data);
    console.log("🌐 [API] Response data keys:", response.data ? Object.keys(response.data) : "null/undefined");
    
    if (response.data) {
      console.log("🌐 [API] dayClosings in response:", response.data.dayClosings);
      console.log("🌐 [API] dayClosings length:", response.data.dayClosings?.length);
      console.log("🌐 [API] totalCount in response:", response.data.totalCount);
    }
    
    return response.data;
  } catch (error) {
    console.error("❌ [API] Error fetching Z Report:", error);
    console.error("❌ [API] Error response:", error.response);
    console.error("❌ [API] Error response data:", error.response?.data);
    console.error("❌ [API] Error response status:", error.response?.status);
    throw error;
  }
};

// API to export Z Report to Excel
export const exportZReportToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/export-z-report-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const dateStr = filter.fromDate ? new Date(filter.fromDate).toISOString().slice(0,10).replace(/-/g, '') : '';
    const toDateStr = filter.toDate ? new Date(filter.toDate).toISOString().slice(0,10).replace(/-/g, '') : '';
    link.setAttribute('download', `Z_Report_${dateStr}_${toDateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting Z Report:", error);
    throw error;
  }
};

